import { useSettings } from '@wix/tpa-settings/react';

import settingsParams from '../../settingsParams';

export const shouldRenderJoinDate = (
  settings: ReturnType<typeof useSettings>,
) => {
  return settings.get(settingsParams.showJoinDate);
};
